import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from 'helpers/constants'

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  mode: 'cors',
  timeout: 30000,
  prepareHeaders: (headers, { endpoint, getState }) => {
    // Skip Content-Type for FormData requests (browser will set it with boundary)
    const isFormData = headers.get('X-FormData-Request') === 'true'
    if (!isFormData) {
      headers.set('Content-Type', 'application/json')
    }
    headers.delete('X-FormData-Request') // Remove marker header

    const token = sessionStorage.getItem('auth_token')
    headers.set('Authorization', `Bearer ${token}`)
    return headers
  },
})

const baseQueryWithReauth = async (args, api) => {
  const result = await baseQuery(args, api, {})
  if (result.error) {
    // TODO: Add Notifications
  }
  return result
}

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  reducerPath: 'apiService',
  tagTypes: [
    'Variety',
    'CropCycle',
    'Region',
    'RegionSuppliers',
    'Certificate',
    'Broker',
    'CertificateCounts',
  ],
})
